import React, { useState } from "react";
import SideNavigation from "./SideNavigation.js";
import LoginHeader from "./LoginHeader.js";
import AADHeader from "./AADHeader.js";

// Renders the normal app shell (header + sidebar) with a "not enough access"
// panel in the content area, so an unauthorized user stays inside the platform
// instead of being redirected out to the full-page /accessdenied screen.
export default function NoAccess({ message }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const toggleSidebar = () => setIsSidebarOpen((o) => !o);
  const loginType = localStorage.getItem("loginType");
  const Header = loginType === "AAD" ? AADHeader : LoginHeader;

  return (
    <div id="wrapper">
      <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        id="page-content-wrapper"
        className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}
      >
        <div
          className="container formpd"
          style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", textAlign: "center", gap: "12px" }}
        >
          <img src="/assets/img/accessdenied.png" alt="" style={{ width: 120, opacity: 0.85 }} onError={(e) => { e.target.style.display = "none"; }} />
          <h3 className="title">Access restricted</h3>
          <p style={{ maxWidth: 480, color: "#555" }}>
            {message || "You don't have permission to view this section. Contact your platform administrator to request access."}
          </p>
        </div>
      </div>
    </div>
  );
}
